// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ca-controls[data-v-f86ecfd0]{display:flex}.ca-controls .ca-tooltip[data-v-f86ecfd0]{flex:1;margin-top:4px;text-align:right}.ca-controls .ca-tooltip>i[data-v-f86ecfd0]{font-size:16px}", ""]);
// Exports
module.exports = exports;
